import { useDispatch, useSelector } from "react-redux"
import { selectRequireAuthentication, setRequireAuthenticationToFalse } from "./authSlice"
import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import { setPathToAuthentication, setPrevPath } from "../path/pathSlice"

const AuthenticationChecker = () => {
    const dispatch = useDispatch()
    const requireAuthentication = useSelector(selectRequireAuthentication)
    const location = useLocation()


    let path = location.pathname
    if (path === "/authentication" || path === "/registration") {
        path = "/profile"
    }

    useEffect(() => { 
        if (requireAuthentication) {
            dispatch(setPrevPath({
                prevpath: path
            }))
            dispatch(setPathToAuthentication())
            dispatch(setRequireAuthenticationToFalse())
        }
    }, [requireAuthentication, dispatch, path])

    return (
        <></>
    )
}

export default AuthenticationChecker